import { render, staticRenderFns } from "./QuizLayout.vue?vue&type=template&id=00b91ad6&scoped=true&lang=pug&"
import script from "./QuizLayout.vue?vue&type=script&lang=ts&"
export * from "./QuizLayout.vue?vue&type=script&lang=ts&"
import style0 from "./QuizLayout.vue?vue&type=style&index=0&id=00b91ad6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b91ad6",
  null
  
)

export default component.exports